import React from 'react';
import bgImage from '../../../assets/servicebanner/Visa.webp';

const Breadcrumb = () => {
  return (
    <div className='hero'>
      <img
        src={bgImage}
        alt='breadcrumb background'
        className='hero-img'
      />
      <ul className='breadcumb'>
        <li>Home</li>
        <li>Visa</li>
      </ul>
    </div>
  );
};

export default Breadcrumb;
